import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { PlanTag } from '../../new-lineup-plan-grid/plan-details/plan-tag/plan-tag';
import style from '../migration-plan-modal.module.less';

export const PlanName = ({ isCurrentPlan, name }) => {
  return (
    <FlexRow className={style['plan-name']}>
      <Text textType={TextType.H2} value={name} />
      <div>
        <PlanTag isCurrentPlan={isCurrentPlan} isPromotionalPlan={!isCurrentPlan} />
      </div>
    </FlexRow>
  );
};
